import { validator } from "@/utils/validator";

export const recoverSchema = validator.object().shape({
  externalId: validator.string().trim().emptyToNull().autoTransformToHalfWidth().label("組織ID").required(),
  email: validator.string().trim().emptyToNull().autoTransformToHalfWidth().label("メールアドレス").required(),
});
